window.onerror = function (msg, src, line, col, err) {
  console.error('GLOBAL ERROR:', {
    msg,
    src,
    line,
    col,
    err,
  })
}

import { createApp } from 'vue'
import App from './App.vue'
import router from './routes/index'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue3-apexcharts'
import axios from './plugins/axios'
import '../public/loader.css'
import './styles/global.css'
import { handleLegacyHashRedirect } from './utils/legacyHashRedirect'

console.log('URL at Vue start:', location.href)
handleLegacyHashRedirect();

console.log('BEFORE CREATE APP')

const app = createApp(App)
app.config.globalProperties.$axios = axios
app.config.globalProperties.$router = router

console.log('BEFORE MOUNT')

app.use(router)
app.use(vuetify)
app.use(VueApexCharts)
app.mount('#app')

console.log('AFTER MOUNT')

setTimeout(() => {
    const loader = document.getElementById('app-loader')
    if (loader) {
    loader.style.opacity = '0'
    setTimeout(() => {
        loader.remove();
    }, 0)
    }
}, 2000);

window.addEventListener('load', () => {
  const loader = document.getElementById('app-loader')
  if (loader) loader.remove()
  console.log('LOADER FORCE REMOVED')
})